import React, {Component} from "react";
import apiLib from "../libs/apiLib";
import "./Invite.css";
import LoaderButton from "./LoaderButton";
import FormControl from "react-bootstrap/es/FormControl";
import {Notification} from 'react-notification';

export default class Invite extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            email: ""
        };
    }

    login(email) {
        return new Promise((resolve, reject) =>
            apiLib.invite(email)
                .then(result => resolve())
                .catch(err => reject(err))
        );
    }

    validateForm() {
        return this.state.email.length > 0;
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    }

    handleSubmit = async event => {
        event.preventDefault();

        this.setState({isLoading: true});

        try {
            await this.login(this.state.email);
            // this.props.userHasAuthenticated(true);
            this.props.props.history.push({
                pathname: "/confirmInvite",
                state: {email: this.state.email}
            });
            this.setState({isLoading: false, error: false});
        } catch (e) {
            this.setState({isLoading: false, error: true});
        }
    }


    render() {
        let notification;
        if (this.state.error === true) {
            notification = (
                <Notification
                    isActive={true}
                    message={"Failed to send the invite, please check the email and try again"}
                />);
        } else{
            notification = (<span></span>);
        }


        return (
            <div>
                <div className="m-b">
                    <strong>Invite your landlord</strong>
                    <p className="text-xs m-t">Please enter the landlord’s email and click invite</p>
                </div>
                <form onSubmit={this.handleSubmit}>
                    <div className="md-form-group">
                        <FormControl
                            autoFocus
                            type="email"
                            id="email"
                            value={this.state.email}
                            onChange={this.handleChange}
                            className="md-input text-info"
                        />
                        <label className="text-info">Landlord Email</label>
                    </div>
                    <LoaderButton
                        className="btn info btn-block p-x-md has-value"
                        disabled={!this.validateForm()}
                        type="submit"
                        isLoading={this.state.isLoading}
                        text="Invite"
                        loadingText="Sending invite…"
                    />
                </form>
                {notification}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Invite.js